import type { FondoContable, FondosContables } from '../../types';

interface Props {
  fondo: FondoContable;
  fondos: FondosContables | undefined;
}

/** Qué cobros suman a cada fondo, para que quien reparte sepa de dónde sale la plata. */
export function FondoTiposIncluidos({ fondo, fondos }: Props) {
  if (!fondos) return null;

  const tipos = fondos[fondo];
  const incluye = fondo === 'escrituras' ? ['cobros de escrituras', ...tipos] : tipos;

  return (
    <p className="text-xs text-muted-foreground">
      {incluye.length > 0 ? `Incluye: ${incluye.join(', ')}` : 'No incluye ningún tipo de trámite'}
    </p>
  );
}
